var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { attrs: { name: "disagree-form", width: 0 } }, [
    _c(
      "div",
      { staticClass: "modal modal__sphir_Online_Access_Agreement show" },
      [
        _c(
          "section",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hide,
                expression: "hide"
              }
            ]
          },
          [
            _c("a", { staticClass: "modal__close" }, [
              _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__head" }, [
              _c("h3", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("JOIN.TITLE")) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__body" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("JOIN.P_10")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__footer text__center margin-t__40" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn__bordered btn__round",
                    on: { click: _vm.returnTo }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("BUTTON.RETURN")) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn__bordered btn__round",
                    on: { click: _vm.view }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("BUTTON.VIEW_CONT")) +
                        "\n                "
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }